import css from "../../css/listing/breadcrumbs.module.css";

import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import isRent from "../../helper/isRent";
import Logo from "../header/Logo";
import { useHistory } from "../common/History";

import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";

const Breadcrumbs = (props) => {
    const { listing, showLogo } = props;
    let { label } = props;

    const history = useHistory();

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(false);
    }, []);

    if (isLoading) {
        return <></>;
    }

    const referrer = history.getPrevious();

    const rent = isRent(listing);

    const baseUrl = rent ? "/homesearch/for_rent/" : "/homesearch/for_sale/";

    if (!label) {
        label = rent ? "For Rent" : "For Sale";
    }

    const category = rent ? "rent" : "sale";

    let backPathname;
    let backQuery;
    let backAsPath;

    if (referrer && referrer.pathname.startsWith("/search")) {
        backPathname = referrer.pathname;
        backQuery = referrer.query;
        backAsPath = referrer.asPath;
    } else {
        backPathname = "/search";
        backQuery = {
            location: listing.zip.url,
            category: category,
        };
        backAsPath = `${baseUrl}${listing.zip.url}`;
    }

    return (
        <div className={css.breadcrumbs}>
            <div className={css.wrapper}>
                {showLogo && (
                    <div className={css.logo}>
                        <Logo size="sm" />
                    </div>
                )}
                <div className={css.back}>
                    <Link
                        href={{
                            pathname: backPathname,
                            query: backQuery,
                        }}
                        as={backAsPath}
                        passHref={true}
                    >

                        <ChevronLeftIcon />Back to Search
                    </Link>
                </div>
                <div className={css.path}>
                    {label}
                    <ChevronRightIcon /> {listing.address}{" "}
                    {listing.unit_number || ""}
                    <ChevronRightIcon />{" "}
                    <Link
                        href={`/search?location=${listing.city.url}&category=${category}`}
                        as={`${baseUrl}${listing.city.url}`}
                        passHref={true}
                    >
                        {listing.city.name}
                    </Link>
                    <ChevronRightIcon />{" "}
                    <Link
                        href={`/search?location=${listing.state.url}&category=${category}`}
                        as={`${baseUrl}${listing.state.url}`}
                        passHref={true}
                    >
                        {listing.state.abbr}
                    </Link>
                    <ChevronRightIcon />{" "}
                    <Link
                        href={`/search?location=${listing.zip.url}&category=${category}`}
                        as={`${baseUrl}${listing.zip.url}`}
                        passHref={true}
                    >
                        {listing.zip.code}
                    </Link>
                </div>
            </div>
        </div>
    );
};

Breadcrumbs.propTypes = {
    listing: PropTypes.object.isRequired,
    showLogo: PropTypes.bool.isRequired,
    label: PropTypes.string,
};

Breadcrumbs.defaultProps = {
    showLogo: false,
};
export default Breadcrumbs;
